<template>
  <div id="app" :class="theme">
    <MainContent :theme="theme" @toggle-theme="toggleTheme" />
  </div>
</template>

<script>
import MainContent from './components/MainContent.vue';
export default {
  name: 'App',
  components: {
    MainContent
  },
  data() {
    return {
      theme: 'light'
    };
  },
  methods: {
    toggleTheme() {
      this.theme = this.theme === 'light' ? 'dark' : 'light';
    }
  }
}
</script>

<style>
:root {
  --primary-color: #007bff;
  --text-color: #2c3e50;
  --text-color-muted: #6c757d;
  --background-color: #fff;
  --card-background-color: #fff;
  --card-shadow-color: rgba(0, 0, 0, 0.05);
  --feature-section-bg: #f8f9fa;
  --border-color: #dee2e6;
  --link-color: #007bff;
  --link-hover-color: #0056b3;
}

#app.dark {
  --primary-color: #0d6efd;
  --text-color: #e9ecef;
  --text-color-muted: #adb5bd;
  --background-color: #121212;
  --card-background-color: #1e1e1e;
  --card-shadow-color: rgba(0, 0, 0, 0.4);
  --feature-section-bg: #1c1c1c;
  --border-color: #343a40;
  --link-color: #3b9dff;
  --link-hover-color: #66baff;
}

body {
  font-family: 'Lato', sans-serif;
  background-color: var(--background-color);
  color: var(--text-color);
  transition: background-color 0.2s ease, color 0.2s ease;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.text-primary {
    color: var(--primary-color) !important;
}

.text-muted {
    color: var(--text-color-muted) !important;
}
</style>
